export function ValidationError({ errorMessage = "" }) {
  return <div className="admin-panel__form-validation-error">{errorMessage}</div>;
}
